import { Box as MuiBox, styled, Typography as MuiTypography } from '@material-ui/core';

import { COLORS } from 'theme/constants';

interface CloseIconProps {
  size?: string;
}

export const CloseIcon = styled(MuiBox)({
  height: ({ size }: CloseIconProps) => size ?? '68px',
  width: ({ size }: CloseIconProps) => size ?? '68px',
  margin: '30px auto',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
  borderRadius: '50%',
  border: '1px solid',
  padding: '15px',

  '& span': {
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '45%',
    height: '45%',
    transform: 'translate(-50%, -50%)',

    '&:before, &:after': {
      backgroundColor: 'currentColor',
      content: '""',
      display: 'block',
      height: '1px',
      left: '0px',
      position: 'absolute',
      top: '50%',
      width: '100%',
    },

    '&:before': {
      transform: 'translateY(-50%) rotate(45deg)',
    },

    '&:after': {
      transform: 'translateY(-50%) rotate(135deg)',
    },
  },
});

export const IFrameCaption = styled(MuiTypography)(({ theme }) => ({
  ...theme.typography.body,
  color: COLORS.cozmosPurple2
}));
